import { render, staticRenderFns } from "./BillingMethodList.vue?vue&type=template&id=53312794"
import script from "./BillingMethodList.vue?vue&type=script&lang=ts"
export * from "./BillingMethodList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports